import axios from "axios";

// Root URL //
const root_url = 'https://www.microchip.com';
// Prod Root URL //
const prod_root_url = 'https://www.microchip.com/sitesearch';
// Header URL //
const header_url = '/bin/fragmentSearch.header.json';
// Foter URL //
const footer_url = '/bin/fragmentSearch.footer.json';
// Search URL //
const search_url = '/api/autosuggestapi/GetAutoSuggest';

export default {

  // Get Header Data //
  async getHeaderData(id) {
    let axiosConfig = {
      headers: {
          "content-Type": "application/json; charset=utf-8"
      }
    };
    const headerEndpointApi = root_url + header_url;
    const response = await axios.get(headerEndpointApi, {
      params: {
        a: id,
      },
      axiosConfig
    });
    return response.data;
  },
  // Get Footer Data //
  async getFooterData() {
    let axiosConfig = {
      headers: {
          "content-Type": "application/json; charset=utf-8"
      }
    };
    const footerEndpointApi = root_url + footer_url;
    const response = await axios.get(footerEndpointApi, {axiosConfig});
    return response.data;
  },
  // Get User Search Data //
  async getUserSearchData(query, timeStampNow) {
    let axiosConfig = {
      headers: {
          "content-Type": "application/json; charset=utf-8"
      }
    };
    const searchEndpointApi = prod_root_url + search_url;
    const response = await axios.get(searchEndpointApi, {
      params: {
        q: query,
        timestamp: timeStampNow,
        limit: 10, 
        doc: 'no'
      },
      axiosConfig
    });
    return response.data;
  },
  
};
